__turbopack_context__.v({
  "backgroundCard": "index-module__tLURaW__backgroundCard",
  "backgroundConfetti": "index-module__tLURaW__backgroundConfetti",
  "buttonContainer": "index-module__tLURaW__buttonContainer",
  "confetti": "index-module__tLURaW__confetti",
  "introTextContainer": "index-module__tLURaW__introTextContainer",
  "mainContainer": "index-module__tLURaW__mainContainer",
  "mobileOnlyLogo": "index-module__tLURaW__mobileOnlyLogo",
  "pegSettle": "index-module__tLURaW__pegSettle",
  "pegWobble": "index-module__tLURaW__pegWobble",
  "prizeSheet": "index-module__tLURaW__prizeSheet",
  "prizeSheetBackground": "index-module__tLURaW__prizeSheetBackground",
  "prizeSheetImage": "index-module__tLURaW__prizeSheetImage",
  "prizeSheetInner": "index-module__tLURaW__prizeSheetInner",
  "spinning": "index-module__tLURaW__spinning",
  "spinningMessage": "index-module__tLURaW__spinningMessage",
  "visible": "index-module__tLURaW__visible",
  "wheel": "index-module__tLURaW__wheel",
  "wheelContainer": "index-module__tLURaW__wheelContainer",
  "wheelInner": "index-module__tLURaW__wheelInner",
  "wheelOuter": "index-module__tLURaW__wheelOuter",
  "wheelPeg": "index-module__tLURaW__wheelPeg",
});
